import React from 'react';
import { services } from '../utils/services';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Services = () => {
    const navigate = useNavigate();
  const handleClick = (item) => {
    navigate(`/services/${item.slug}`)
  };
  return (
    <div>
      {/* Services Section */}
      <section className="px-4 md:px-20 py-16 bg-[#030303]">
        <h2 className="text-2xl md:text-4xl font-extrabold text-center mb-8 md:mb-12 text-white">
          Our <span className="text-blue-500">Services</span>
        </h2>

        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10"
          initial="hidden"
          animate="show"
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.12 } }
          }}
        >
          {services.map((service) => (
            <motion.div
              key={service.id}
              role="button"
              tabIndex={0}
              onClick={() => handleClick(service)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') handleClick(service);
              }}
              className="group cursor-pointer"
              variants={{
                hidden: { opacity: 0, y: 12, scale: 0.98 },
                show: { opacity: 1, y: 0, scale: 1 },
              }}
              whileHover={{ scale: 1.03 }}
              transition={{ type: 'spring', stiffness: 260, damping: 20 }}
            >
              <div className="relative rounded-2xl overflow-hidden bg-gradient-to-b from-[#1a1a1a] to-[#111111] shadow-lg hover:shadow-2xl hover:shadow-blue-600/30 border border-transparent group-hover:border-blue-500 transition-all duration-300">
                <div className="p-6 md:p-8 flex flex-col h-full">

                  <h3 className="text-xl md:text-2xl font-semibold text-center text-blue-400 mb-2">
                    {service.name}
                  </h3>
                  <p className="text-center text-gray-300 text-sm md:text-base mb-6 flex-1">{service.summary}</p>

                  {/* <div className="mt-auto flex items-center justify-center">
                    <span className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-full text-sm font-medium hover:bg-blue-500 transition-colors">
                     
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </span>
                  </div> */}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </section>
    </div>
  );
};

export default Services;
